import Page from './components/Quote/Page/Page';

function App() {
  return (
    <div>
      <Page />
    </div>
  );
}

export default App;
